import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import SubAccountTable from "../SubAccountTable";

export default function SubAccount() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY}>
      <SubAccountTable />
    </GoogleReCaptchaProvider>
  );
}
